export var AuthNextStep;
(function (AuthNextStep) {
    AuthNextStep["SignIn"] = "sign-in";
    AuthNextStep["SignUp"] = "sign-up";
})(AuthNextStep || (AuthNextStep = {}));
export var AuthSessionStatus;
(function (AuthSessionStatus) {
    AuthSessionStatus["NeedsProfile"] = "needsProfile";
    AuthSessionStatus["NeedsBusiness"] = "needsBusiness";
    AuthSessionStatus["Ready"] = "ready";
})(AuthSessionStatus || (AuthSessionStatus = {}));
//# sourceMappingURL=auth.js.map